import React, { useEffect, useState } from "react";
import axios from "axios";

const url = "https://eightthsemnewfood.onrender.com";

function Myorder() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      const email = localStorage.getItem("useremail");
      try {
        const res = await axios.post(`${url}/myorder`, { email });
        if (res.data.success) {
          setOrders(res.data.orders);
        } else {
          alert("⚠️ Failed to fetch orders.");
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
        alert("❌ Something went wrong while loading orders.");
      }
    };

    fetchOrders();
  }, []);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Your Orders</h2>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        orders.map((order, index) => (
          <div key={index} style={{ marginBottom: "2rem", borderBottom: "1px solid #ccc", paddingBottom: "1rem" }}>
            <h4>Order #{index + 1}</h4>
            {order.orderdata.length > 0 && order.orderdata[0].date && (
              <p>
                <strong>Date:</strong> {new Date(order.orderdata[0].date).toLocaleString()}
              </p>
            )}

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ backgroundColor: "#f0f0f0" }}>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Name</th>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Qty</th>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Size</th>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Price</th>
                </tr>
              </thead>
              <tbody>
                {order.orderdata.slice(1).map((item, idx) => (
                  <tr key={idx}>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>{item.name}</td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>{item.qty}</td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>{item.size}</td>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>₹{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
}

export default Myorder;
